/* unplugin-vue-components disabled */import { render } from "./UserAgreementIos.vue?vue&type=template&id=7c676ce8&scoped=true"
import script from "./UserAgreementIos.vue?vue&type=script&lang=js"
export * from "./UserAgreementIos.vue?vue&type=script&lang=js"

import "./UserAgreementIos.vue?vue&type=style&index=0&id=7c676ce8&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c676ce8"]])

export default __exports__